





















































































































































import ClassItem from '@/models/interfaces/ClassItem';
import JourneyParameters from '@/models/interfaces/JourneyParameters';
// Models
import SurveyAnswer from '@/models/SurveyAnswer';
// SDK
import Indicators, { Rating } from '@solucx/indicators';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Anonym from '../components/Form/Anonym.vue';
// Form Components
import Classes from '../components/Form/Classes/Classes.vue';
import Comment from '../components/Form/Comment.vue';
import SendButton from '../components/Form/SendButton.vue';
// Text Component
import IntroText from '../components/IntroText.vue';
import EmoticonDisplay from '../components/ScoreDisplay/EmoticonDisplay.vue';
// Score Displays
import NumberDisplay from '../components/ScoreDisplay/NumberDisplay.vue';
// Score Input
import ScoreInput from '../components/ScoreInput/ScoreInput.vue';
// Holders
import SoluCXFooter from '../components/SoluCXFooter.vue';
import SurveyCard from '../components/SurveyCard.vue';
import AcceptanceContactIfDetractor from '@/components/AcceptanceContactIfDetractor.vue';
import AcceptanceContactIfNeutral from '@/components/AcceptanceContactIfNeutral.vue';
import AcceptanceContactIfPromoter from '@/components/AcceptanceContactIfPromoter.vue';
import ContactChannelCheckboxes from '@/components/ContactChannelCheckboxes.vue';

@Component({
  components: {
    ScoreInput,
    SoluCXFooter,
    SurveyCard,
    IntroText,
    NumberDisplay,
    EmoticonDisplay,
    SendButton,
    Classes,
    Comment,
    Anonym,
    AcceptanceContactIfDetractor,
    AcceptanceContactIfNeutral,
    AcceptanceContactIfPromoter,
    ContactChannelCheckboxes,
  },
})
export default class DigitalForm extends Vue {
  @Prop() public value!: SurveyAnswer;
  @Prop() public parameters!: JourneyParameters;
  @Prop() public items!: ClassItem[];
  @Prop() public allowPointer!: boolean;
  @Prop() public sending!: boolean;
  @Prop() public route: Route;

  public isCommentRequiredAndHasNoComments: boolean = false;

  public get activeContactIfDetractor(): boolean {
    return this.isDetractor && this.parameters.showAcceptanceContactIfDetractor === true;
  }

  public get whiteMode() {
    // Todo verificar "white" e "White" também;
    return this.parameters.color === '#ffffff';
  }

  public get isTabletOrTotem(): boolean {
    return this.route.name === 'totem' || this.route.name === 'tablet';
  }

  public get isLockScroll(): boolean {
    if (this.parameters.lockScroll === null) {
      return this.isTabletOrTotem;
    }
    return this.parameters.lockScroll;
  }

  public get isCommentVisible(): boolean {
    if (this.parameters.showComment === null && this.isTabletOrTotem) return false;
    return this.parameters.showComment;
  }

  public get hasNegativeScore(): boolean {
    const type = Number(this.value.journeyType);
    const indicator = Indicators.getIndicator(type);
    const rating = indicator.getRating(this.value.score);
    return this.value.score != null && rating === Rating.NEGATIVE;
  }

  public get isPositiveCommentVisible(): boolean {
    if (this.hasNegativeScore && !!this.parameters.commentNegativeLabel) return false;
    return this.isCommentVisible;
  }

  public get isNegativeCommentVisible(): boolean {
    if (!this.hasNegativeScore || !this.parameters.commentNegativeLabel) return false;
    return this.isCommentVisible;
  }

  public get isDetractor(): boolean {
    return this.value.getRating() === Rating.NEGATIVE;
  }

  public get commentLabel(): string {
    const hasPositivePlaceholder: boolean = !!this.parameters.commentLabel;
    const hasCommentNegativeLabel: boolean = !!this.parameters.commentNegativeLabel;

    if (hasPositivePlaceholder && !this.isDetractor) return this.parameters.commentLabel;
    if (hasCommentNegativeLabel && this.isDetractor) return this.parameters.commentNegativeLabel;
    if (hasPositivePlaceholder) return this.parameters.commentLabel;
    else return this.$tc('howCouldWeImprove');
  }

  public get indicator() {
    switch (this.parameters?.inputType) {
      case 'csat':
      case 'csat5Stars':
      case 'csat5Buttons':
        return 'csat';
      case 'esat':
      case 'esat5Stars':
      case 'esat5Buttons':
        return 'esat';
      case 'ces':
      case 'cesButtons':
      case 'cesStars':
        return 'ces';
      case 'ees':
      case 'eesButtons':
      case 'eesStars':
        return 'ees';
      case 'csat10':
      case 'csat10slider':
      case 'csat10arrow':
        return 'csat10';
      case 'enpsAarrow':
      case 'enpsButtons':
      case 'enpsSlider':
      case 'enpsGradientButtonsColored':
      case 'enpsButtonsColored':
        return 'enps';
      default:
        return 'nps';
    }
  }

  public get getMethodTerms(): string[] {
    let { methodTerms } = this.parameters;
    if (!methodTerms) {
      methodTerms = { [this.indicator]: [] };
    }
    return methodTerms[this.indicator];
  }

  public mounted() {
    this.setPropertiesDefaultValue();
  }

  public setPropertiesDefaultValue(): void {
    this.value.setDefaultValueBasedOnJourneyType();
    this.value.setAcceptanceContactDefaultValue(this.parameters);
  }

  public checkRequiredFieldsAndSubmitSurveyAnswer(): void {
    this.validateCommentaryField();

    if (this.isCommentRequiredAndHasNoComments) return;

    this.submitSurveyAnswer();
  }

  public validateCommentaryField(): void {
    this.isCommentRequiredAndHasNoComments =
      this.parameters.isCommentRequired && (!this.value?.comment || this.value.comment?.trim().length === 0);
  }

  public submitSurveyAnswer(): void {
    this.$emit('submit', this.value);
  }

  public emitPartial(trigger: string) {
    this.$emit('submitPartial', this.value, trigger);
  }

  @Watch('value.comment')
  public updateCommentaryFieldValidation(): void {
    this.validateCommentaryField();
  }
}
